import { ReportsDashboard } from './reports-dashboard-component'

export default ReportsDashboard
export * from './reports-dashboard-component'
